/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
import React, { Fragment } from 'react';

import sortIcon from 'assets/images/sort-arrow.png';
import CurrencySign from 'components/price/CurrencySign.component';
import { LOCALE, withTranslation } from 'providers/GILT.provider';
import fixed from 'utils/values/fixed.util';
import parsfixed from 'utils/values/parsfixed.util';

import { STOCK_SOLD_PDF_TABLE_ID } from 'stocks/consts';

import CN from './TableStocksUsedSold.module.scss';

class TableStocksUsedSold extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.getWindowScrollTop();
  }

  getWindowScrollTop = () => {
    if (window.pageYOffset) {
      return window.pageYOffset;
    } else if (document.documentElement) {
      return document.documentElement.scrollTop;
    }
    return 0;
  };

  searchFunc = (el) =>
    el
      .getName()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .toLocaleString(LOCALE.uk)
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[\u00E9]/g, '')
      .search(this.props.search) !== -1 ||
    el
      .getBrand()
      .trim()
      .normalize('NFD')
      .replace(/^0+'/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .toLocaleString(LOCALE.uk)
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    el
      .getFamily()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .toLocaleString(LOCALE.uk)
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    el
      .getCategory()
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .toLocaleString(LOCALE.uk)
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1 ||
    (el.barcode ? el.barcode.toString() : '')
      .trim()
      .normalize('NFD')
      .replace(/^0+/, '')
      .replace(/’/, '')
      .replace(/'/, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u00E9]/g, '')
      .toLowerCase()
      .search(this.props.search) !== -1;

  render() {
    const { t } = this.props;
    const categoryKeys = this.props.data.filter(this.searchFunc);
    return (
      <table id={STOCK_SOLD_PDF_TABLE_ID} className={CN.container}>
        <thead>
          <tr>
            <th className="brand-name">
              <span
                role="button"
                tabIndex={0}
                onClick={() => {
                  this.props.onAddSort('brand');
                }}
              >
                <span>{t('stocks.tableHeaders.brand')}</span>
                <img src={sortIcon} alt="Sort by Brand" />
              </span>
            </th>
            <th className="product-name">
              <span
                role="button"
                tabIndex={0}
                onClick={() => {
                  this.props.onAddSort('title');
                }}
              >
                <span>{t('stocks.tableHeaders.productName')}</span>
                <img src={sortIcon} alt="Sort by product" />
              </span>
            </th>
            <th style={{ width: '78px' }}>
              <span
                role="button"
                tabIndex={0}
                className="two-lines"
                onClick={() => {
                  this.props.onAddSort('quantity');
                }}
              >
                <span>{t('stocks.tableHeaders.stockQuantity')}</span>
                <img src={sortIcon} alt="Sort by quantity" />
              </span>
            </th>
            <th style={{ width: '70px' }}>
              <span
                role="button"
                tabIndex={0}
                onClick={() => {
                  this.props.onAddSort('used');
                }}
              >
                <span>{t('stocks.tableHeaders.used')}</span>
                <img src={sortIcon} alt="Sort by used" />
              </span>
            </th>
            <th style={{ width: '60px' }}>
              <span
                role="button"
                tabIndex={0}
                onClick={() => {
                  this.props.onAddSort('sold');
                }}
              >
                <span>{t('stocks.tableHeaders.sold')}</span>
                <img src={sortIcon} alt="Sort by sold" />
              </span>
            </th>
            <th className="cost-price">
              <span role="button" tabIndex={0}>
                <span>{t('stocks.tableHeaders.costPrice')}</span>
              </span>
            </th>
            <th className="cost-used">
              <span
                role="button"
                tabIndex={0}
                className="two-lines"
                onClick={() => {
                  this.props.onAddSort('costOfUsed');
                }}
              >
                <span>{t('stocks.tableHeaders.usedCost')}</span>
                <img src={sortIcon} alt="Sort by cost used" />
              </span>
            </th>
            <th>
              <span
                role="button"
                tabIndex={0}
                className="two-lines cost-sold"
                onClick={() => {
                  this.props.onAddSort('costOfSold');
                }}
              >
                <span>{t('stocks.tableHeaders.soldCost')}</span>
                <img src={sortIcon} alt="Sort by cost sold" />
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          {categoryKeys.map((key) => {
            const stocks = key;
            return (
              <Fragment key={stocks.id}>
                <tr>
                  <td
                    role="button"
                    tabIndex={0}
                    className="brand-name"
                    onClick={() => {
                      this.props.OnClickRow(stocks);
                    }}
                  >
                    <span>{stocks.brand ? stocks.brand : t('common.unknown')}</span>
                  </td>
                  <td
                    role="button"
                    tabIndex={0}
                    className="product-name"
                    onClick={() => {
                      this.props.OnClickRow(stocks);
                    }}
                  >
                    {stocks.title}
                  </td>
                  <td style={{ width: '58px', textAlign: 'center' }}>{fixed(stocks.units_in_stock)}</td>
                  <td style={{ width: '58px', textAlign: 'center' }}>{stocks.usedSoldInRangeData ? fixed(stocks.usedSoldInRangeData.used) : 0}</td>
                  <td style={{ width: '78px', textAlign: 'center' }}>{stocks.usedSoldInRangeData ? stocks.usedSoldInRangeData.sold : 0}</td>
                  <td className="cost-price-body-td">
                    {stocks.cost_price ? (
                      <>
                        <CurrencySign />
                        {stocks.cost_price}
                      </>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td className="cost-used-body-td">
                    {stocks.cost_price && stocks.usedSoldInRangeData && stocks.usedSoldInRangeData.used > 0 ? (
                      <>
                        <CurrencySign /> {stocks.usedSoldInRangeData.used * parsfixed(stocks.cost_price)}
                      </>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td className="cost-sold-body-td">
                    {stocks.cost_price && stocks.usedSoldInRangeData && stocks.usedSoldInRangeData.sold > 0 ? (
                      <>
                        <CurrencySign />
                        {stocks.usedSoldInRangeData.sold * parsfixed(stocks.cost_price)}
                      </>
                    ) : (
                      '-'
                    )}
                  </td>
                </tr>
              </Fragment>
            );
          })}
          {categoryKeys.length === 0 && (
            <tr>
              <td colSpan={6} className={CN.noProductsMsg}>
                {t('stocks.stockManagerTable.noProductsMsg')}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
}

const TableStocksUsedSoldHoc = withTranslation()(TableStocksUsedSold);
export default TableStocksUsedSoldHoc;
